(function () {
  if (customElements.get('hm-page-nav')) return;

  class HmPageNav extends HTMLElement {
    connectedCallback() {
      this.links = Array.prototype.slice.call(this.querySelectorAll('[data-hm-nav-link]'));
      if (!this.links.length) return;

      this.onClick = this.onClick.bind(this);
      this.onHash = this.onHash.bind(this);
      this.links.forEach(function (a) {
        a.addEventListener('click', this.onClick);
      }, this);
      window.addEventListener('hashchange', this.onHash);
      this.sync(location.hash);
      this.observe();
    }

    disconnectedCallback() {
      this.links.forEach(function (a) {
        a.removeEventListener('click', this.onClick);
      }, this);
      window.removeEventListener('hashchange', this.onHash);
      if (this.io) this.io.disconnect();
    }

    hrefOf(a) {
      return (a.getAttribute('href') || '').trim();
    }

    onClick(event) {
      var href = this.hrefOf(event.currentTarget);
      if (href.charAt(0) !== '#') return;
      this.sync(href);
      if (!this.hasAttribute('data-hm-smooth')) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (window.history && window.history.pushState) window.history.pushState(null, '', href);
    }

    onHash() {
      this.sync(location.hash);
    }

    sync(hash) {
      if (!hash || hash === '#') {
        this.links.forEach(function (a) {
          a.classList.remove('is-active');
          a.removeAttribute('aria-current');
        });
        return;
      }
      this.links.forEach(function (a) {
        var on = this.hrefOf(a) === hash;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'location');
        else a.removeAttribute('aria-current');
      }, this);
    }

    observe() {
      if (!('IntersectionObserver' in window)) return;
      var ids = [];
      this.links.forEach(function (a) {
        var href = this.hrefOf(a);
        if (href.charAt(0) !== '#') return;
        var id = href.slice(1);
        if (id && document.getElementById(id)) ids.push(id);
      }, this);
      if (!ids.length) return;

      var self = this;
      this.io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) self.sync('#' + entry.target.id);
          });
        },
        { rootMargin: '-25% 0px -60% 0px', threshold: 0.01 }
      );
      ids.forEach(function (id) {
        self.io.observe(document.getElementById(id));
      });
    }
  }

  customElements.define('hm-page-nav', HmPageNav);
})();
